import { Logger } from '@core/logger';

export const logStorage = (methodName: string) => {
  Logger.logDebug(`Call ${methodName}`, { library: 'core-storage' });
};
